import { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import Stepper from '../Stepper';
import { IOyanaResponse } from '../../../services/me.service';
import { FormControl, FormControlLabel, Radio } from './styled';
import { WrapperActions } from '../ManagerStepper/styled';
import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import useCreateJourneyRecurrentUser from '../../../domain/useCreateJourneyRecurrent';
import AlertMessage from '../../atoms/AlertMessage';
import { useRedirectToLandingPage } from '../../../domain/useRedirectToLandingPage';
import PageLoading from '../Loading';
import { dynamicCustomEventTracking } from '../../../lib/gtm';

interface SoftLoginFormProps {
  token?: string;
  onChange: (loggedIn: boolean) => void;
  user?: IOyanaResponse;
}

const SoftLoginForm = ({ token, onChange, user }: SoftLoginFormProps) => {
  const { handleCreateJourneyRecurrent, errorJourney, isLoadingJourney } = useCreateJourneyRecurrentUser();
  const { handleRedirectToLandingPage } = useRedirectToLandingPage();

  const [value, setValue] = useState('existing');
  const navigate = useNavigate();
  const handleNextPage = () => {
    onChange(value === 'existing');
    if (token && value === 'existing') {
      dynamicCustomEventTracking.send({ dynamicEventName: 'journey_quick_access_softlogin_ag' });
      handleCreateJourneyRecurrent({ token: token });
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.value;
    setValue(selected);
  };

  return (
    <>
      {isLoadingJourney && <PageLoading />}

      <Grid container>
        <Grid item xs={12}>
          <Box sx={{ mb: 4 }}>
            <Stepper separator="de" text="Dados pessoais" />
          </Box>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h3">Como deseja continuar?</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sx={{ mb: 7 }}>
          <FormControl>
            <RadioGroup value={value} onChange={handleChange} sx={{ gap: '20px' }}>
              {user && (
                <FormControlLabel
                  value="existing"
                  control={<Radio />}
                  label={
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography
                        component="span"
                        variant="body1"
                        sx={{ display: 'block', fontWeight: 'bold', color: 'neutrals.lead', lineHeight: 1.36, mb: '10px' }}
                      >
                        {user.fullName}
                      </Typography>
                      <Typography
                        component="span"
                        variant="body1"
                        sx={{ display: 'block', color: 'neutrals.lead', lineHeight: 1.36 }}
                      >
                        CPF: {user.cpf}
                      </Typography>
                    </Box>
                  }
                />
              )}
              <FormControlLabel
                value="new"
                control={<Radio />}
                label={
                  <Typography component="span" variant="body1" sx={{ color: 'neutrals.lead', lineHeight: 1.36 }}>
                    Fazer login em outra conta
                  </Typography>
                }
              />
            </RadioGroup>
          </FormControl>
          <WrapperActions>
            <Button
              variant="contained"
              color="secondary"
              disabled={false}
              sx={{ visibility: 'visible', padding: '12px 24px 14px 16px' }}
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
              <Typography variant="body1" sx={{ ml: 1.5 }}>
                Voltar
              </Typography>
            </Button>

            <LoadingButton
              loading={false}
              variant="contained"
              onClick={handleNextPage}
              disabled={value.length === 0}
              sx={{ padding: '12px 16px 14px 24px' }}
            >
              <Typography variant="body1" sx={{ mr: 1.5 }}>
                Continuar
              </Typography>
              <ArrowForwardIcon />
            </LoadingButton>
          </WrapperActions>
        </Grid>
      </Grid>

      {errorJourney && (
        <AlertMessage
          text={'Não conseguimos criar sua jornada, tente novamente mais tarde.'}
          textButton="Entendi"
          type="error"
          handler={() => {
            handleRedirectToLandingPage();
          }}
        />
      )}
    </>
  );
};

export default SoftLoginForm;
